module.exports = __webpack_public_path__ + "img/img28.4f8684bf.png";